// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const MAP_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  SCALE_RANGE_MIN: 'map.scaleRange.min',
  SCALE_RANGE_MAX: 'map.scaleRange.max',
  LABEL_ENABLED: 'map.label.enabled',
  LABEL_FONT_SIZE: 'map.label.fontSize',
  LABEL_FONT_FACE_BOLD: 'map.label.fontFace.bold',
  LABEL_FONT_FACE_ITALIC: 'map.label.fontFace.italic',
  LABEL_COLOR: 'map.label.color',
  LABEL_TEXT_EFFECT: 'map.label.textEffect',
  LABEL_VISIBILITY_MODE: 'map.label.visibilityMode',
  LEGEND_ENABLED: 'map.legend.enabled',
  LINE_STYLE: 'map.line.style',
  LINE_WIDTH: 'map.line.width',
  LINE_START: 'map.line.start',
  LINE_END: 'map.line.end',
  FILL_ENABLED: 'map.fill.enabled',
  FILL_STYLE: 'map.fill.style',
  FILL_BACKGROUND_COLOR: 'map.fill.backgroundColor',
  BORDER_ENABLED: 'map.border.enabled',
  BORDER_WIDTH: 'map.border.width',
  BORDER_COLOR: 'map.border.color',
  BORDER_STYLE: 'map.border.style',
  POINT_ROTATION: 'map.point.rotation',
  POINT_SYMBOLIZATION: 'map.point.symbolization',
  POINT_SHAPE: 'map.point.shape',
  POINT_IMAGE_REPOSITORY: 'map.point.image.repository',
  POINT_IMAGE_CONTENT_IDENTIFIER: 'map.point.image.contentIdentifier',
  POINT_IMAGE_SIGNATURE: 'map.point.image.signature',
  POINT_SIZE: 'map.point.size',
  OPACITY: 'map.polygon.opacity',
  PIE_CHART_SIZE: 'map.pieChart.size',
  PIE_CHART_VALUE_LABELS: 'map.pieChart.valueLabels',
  PIE_CHART_SHOW_TOTALS: 'map.pieChart.showTotals',
  HEATMAP_OPACITY: 'map.heatmap.opacity',
  HEATMAP_GRADIENT: 'map.heatmap.gradient',
  HEATMAP_GRADIENT_REVERSE: 'map.heatmap.gradient.reverse',
  HEATMAP_RADIUS_VALUE: 'map.heatmap.radius.value',
  HEATMAP_RADIUS_UNIT: 'map.heatmap.radius.unit',
  HEATMAP_COMPRESSION: 'map.heatmap.compression',
  HEATMAP_GRADIENT_TRANSPARENCY_ENABLED: 'map.heatmap.gradient.transparency.enabled',
  MAP_PIE_CHART_MAX_MEASURES: 'map.pieChart.maxMeasures',
  INFO_WINDOW_DESCRIPTION: 'map.infoWindow.description',
  INFO_WINDOW_ATTRIBUTE: 'map.infoWindow.attribute'
} as const;

/** @see net/disy/cadenza/workbook/model/MapDataViewSettingsKey.java */
export type MapDataViewSettingsKey = keyof typeof MAP_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const MapDataViewSettingsKey = {
  values: Object.keys(MAP_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly MapDataViewSettingsKey[],
  toPersistenceKey: (value: MapDataViewSettingsKey) => MAP_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = MapDataViewSettingsKey.values.find(key => MAP_DATA_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No MapDataViewSettingsKey for key: ${persistenceKey}`); }
    return value;
  }
} as const;

// </GENERATED-CODE>

/**
 * Values for the key MapDataViewSettingsKey 'PIE_CHART_SIZE'.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/map/web/visualization/config/PieChartSize.java
 */
export const PIE_CHART_SIZE = {
  CONSTANT: 'constant',
  PROPORTIONAL: 'proportional'
};

/**
 * Values for the key MapDataViewSettingsKey 'PIE_CHART_VALUE_LABELS'.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/map/web/visualization/config/PieChartValueLabels.java
 */
export const PIE_CHART_VALUE_LABELS = {
  NONE: 'none',
  VALUE: 'value',
  PERCENTAGE: 'percentage'
};

/**
 * Values for the key MapDataViewSettingsKey 'HEATMAP_RADIUS_UNIT'.
 *
 * @enum {string}
 * @readonly
 * @see net/disy/cadenza/workbook/map/web/visualization/config/HeatmapRadiusUnits.java
 */
export const HEATMAP_RADIUS_UNITS = [
  'kilometers',
  'meters',
  'pixels'
];

export type HeatmapRadiusUnit = typeof HEATMAP_RADIUS_UNITS[ number ];
